import ErrorComponent from "./ErrorComponent";

export { ErrorComponent };
